<template>
    <Button
        v-bind="$props"
        :noPadding="true"
        :variant="variant"
        :ariaLabel="ariaLabel"
        color="black" />
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import Button, { buttonProps } from './Button.vue';
    import { Variant } from '@ui/components/Button/Button.interfaces';

    export default defineComponent({
        name: 'ButtonIcon',
        components: { Button },
        props: {
            ...buttonProps,

            variant: {
                type: String as PropType<Variant>,
                default: 'border',
            },
            ariaLabel: {
                type: String,
                required: true,
            },
        },
    });
</script>
